import { render, staticRenderFns } from "./depart-checker.vue?vue&type=template&id=4f758950&scoped=true&"
import script from "./depart-checker.vue?vue&type=script&lang=js&"
export * from "./depart-checker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f758950",
  null
  
)

export default component.exports